import { useQuery } from '@tanstack/react-query';

import { appendScript } from '@utilities/scripts';

export const useScript = (src: string, id: string) => {
  const { isSuccess, isError } = useQuery({
    queryKey: ['script', src, id],
    queryFn: () => appendScript(src, id),
  });

  return [isSuccess, isError];
};
